import { render, staticRenderFns } from "./ProjectDataTab.vue?vue&type=template&id=656cff9e"
import script from "./ProjectDataTab.vue?vue&type=script&lang=js"
export * from "./ProjectDataTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports